import React from "react";
import { LuSendHorizonal } from "react-icons/lu";
import { Tooltip } from "@material-tailwind/react";
import { PlusIcon } from "@heroicons/react/24/solid";
import { getId } from "../../api/axiosInstanceApi";
import { useNavigate, useOutletContext } from "react-router-dom";
import { MdEdit } from "react-icons/md";

interface TextAreaWithButtonProps {
  prompt: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onGenerateResponse: () => void;
  setIsContextBoxVisible: any;
  contextValue: string;
  disableContextButton: boolean;
  isContextEditable: boolean;
  isLoading: boolean;
}

export const TextAreaWithButton = ({
  prompt,
  onChange,
  onGenerateResponse,
  setIsContextBoxVisible,
  contextValue,
  isContextEditable,
  disableContextButton,
  isLoading,
}: TextAreaWithButtonProps) => {
  const isSidebarOpen = useOutletContext();
  const navigate = useNavigate();
  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      if (!isLoading && prompt.trim().length > 0) {
        onGenerateResponse();
      }
    }
  };
  const clickToCreateNewThought = async () => {
    try {
      const idResponse = await getId();

      const id = await idResponse.data;
      console.log("epoch time: ", id.Id);
      navigate(`/interaction/${id.Id}`, { state: { from: "new" } });
      location.reload();
    } catch (error) {
      console.error("Failed to fetch ID and navigate", error);
    }
  };
  return (
    <div className="fixed bottom-0 md:pt-0 dark:border-white/20 sm:w-[calc(100%-6rem)]   w-full  html_bg_color">
      <div
        className={`mt-3   ${
          isSidebarOpen ? "relative right-10" : " relative right-3"
        } flex items-center justify-center`}
      >
        <div className=" w-[70vw] sm:w-8/12">
          <div className="flex">
            <textarea
              className="rounded-xl resize-none border sm:p-2 px-2 shadow-2xl w-full card_bg_color card_text_color"
              id="promptInput"
              placeholder="Let's interact"
              value={prompt}
              autoFocus
              onChange={onChange}
              onKeyDown={handleKeyDown}
            />
            <button
              onClick={onGenerateResponse}
              disabled={!prompt.trim() || isLoading}
              className="heading_text_color text-2xl ml-2 "
            >
              {!prompt.trim() || isLoading ? (
                <LuSendHorizonal />
              ) : (
                <Tooltip
                  content="Send"
                  placement="top"
                  className=" bg-slate-800 heading_text_color font-bold p-2"
                >
                  <div>
                    <LuSendHorizonal />
                  </div>
                </Tooltip>
              )}
            </button>
            <div className=" hidden sm:inline-flex sm:items-center sm:justify-center pl-3">
              <Tooltip
                content="New Interaction"
                placement="right"
                className=" bg-slate-800 heading_text_color font-bold p-2"
              >
                <div
                  onClick={clickToCreateNewThought}
                  className=" hover:cursor-pointer"
                >
                  <PlusIcon className="arrow-icon heading_text_color h-8 w-8 font-bold" />
                </div>
              </Tooltip>
            </div>
          </div>
          
          {/* with text-ellipsis */}
          <div className="text-center ">
            <div className="inline card_text_color text-md max-w-xs sm:max-w-md overflow-hidden text-ellipsis whitespace-nowrap">
              <div className="flex items-center justify-center">
                <span
                  title={contextValue}
                  className="overflow-hidden text-ellipsis whitespace-nowrap"
                >
                  Your Role: {contextValue}
                </span>
                {isContextEditable && !disableContextButton && (
                  <MdEdit
                    className="cursor-pointer ml-2 mt-1 w-4 h-4 flex-shrink-0"
                    onClick={() => setIsContextBoxVisible(true)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="  text-center">
        <div className="inline-block card_text_color text-md">
          <div className="flex items-center justify-center">
            <span className="">Your Role: &nbsp; {contextValue} &nbsp;</span>
            {isContextEditable && !disableContextButton && <MdEdit className="cursor-pointer" onClick={() => setIsContextBoxVisible(true)}/>}
          </div>
        </div>
      </div> */}

      {/* Mobile view  */}
      <div
        className={`flex justify-center relative right-8  py-1 gap-3 sm:hidden w-full text-center	${
          isSidebarOpen && " right-16"
        }`}
      >
        <div className=" inline-block  sm:hidden pl-3">
          <div className="flex gap-10">
            <div
              onClick={clickToCreateNewThought}
              className="rounded-md px-1 hover:cursor-pointer grid col-span-1"
            >
              <div className="flex items-center justify-center col-span-1">
                <PlusIcon className=" heading_text_color bg-slate-800 h-5 w-5 rounded-full" />
              </div>
              <span
                className="heading_text_color text-xs"
                style={{ fontSize: "0.50rem", lineHeight: "0.6rem" }}
              >
                New Interaction
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
